// Duración de un servicio para leer de un vistazo: «45 min», «1 h», «1 h 30 min». Sin «~» ni
// abreviaturas raras (ver el criterio de copy de Ágora).
export function formatDuration(minutes) {
  const total = Math.round(Number(minutes));
  if (!Number.isFinite(total) || total <= 0) return '';
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (!hours) return `${rest} min`;
  return rest ? `${hours} h ${rest} min` : `${hours} h`;
}
